export const LATEST_CONTACT_KEY_NAME: string = "lastContact";

export const CLEAR_LAST_CONTACT_MSG_VERBIAGE: string = "Are you sure you want to forget last contact? You will no longer have the option to automatically plug their info into a new appointment."